module.exports = __webpack_public_path__ + "img/03-B06.910ae43c.png";